import { useQuery } from "react-query";
import { getHierarchyActivityById } from "../../../../actions/OfficeHierarchy";

export const useOfficeHierarchyActivityTable = (officeHierarchyId) => {
  return useQuery(
    ["GetOfficeHierarchyActivity", officeHierarchyId],
    () => getHierarchyActivityById(officeHierarchyId),
    {
      refetchOnWindowFocus: false,
    }
  );
};
